import { ClientServiceType } from '../services/client-service';
import Client from '../models/client';

export class ListClientsInteractor {
  clientService: ClientServiceType;

  constructor(clientService: ClientServiceType) {
    this.clientService = clientService;
  }

  async listClients(filter: any, txt: string): Promise<Client[]> {
    return this.clientService.listClients(filter, txt);
  }

  async getClientBySlug(slug: string): Promise<Client> {
    return this.clientService.getClientBySlug(slug);
  }
}
